import React, {useEffect} from 'react';
import DropdownComponent from '../Components/DropdownComponent';

/**
 * @param {[][]} props.component - 2d array  which contains for every row of a form the inside components
 * @param {setState} props.setComponents - hook method that handle components variable
 * @param {[][]} props.typeFields - 2d array which contains for every row of a form the types of the inside components  
 * @param {setState} props.setTypeFields - hook method that handle typeFields variable
 * @param {number} props.formRowIndex - index of examined row of a form
 * @param {number} props.indexComponent - index of checkbox component inside row with components
 * @param {boolean} props.clickedChangeElement - variable that is used to render dropdown button component
 * @param {method} props.setClickedChangeElement - hook method that handle clickedChangeElement
 * @param {boolean} props.openAlert - state that opens/closes edit form pop up 
 * @returns component that represent button inside a row of a form with all the available options for the dropdown button
 */
const DropdownDataComponent = (props) => {

    const {
        components,
        setComponents,
        typeFields,
        setTypeFields,
        formRowIndex,
        indexComponent,
        clickedChangeElement,
        setClickedChangeElement,
        openAlert
    }= props

    const [dropdownButtonText, setDropdownButtonText] = React.useState(''); // text of dropdown button 
    const [options, setOptions] = React.useState([]); // menu options of dropdown button 
    const [clickedDeleteFirst, setClickedDeleteFirst] = React.useState(false); // state that defines if first option of dropdown menu has been clicked to be deleted 
    const [lockDeleteOption, setLockDeleteOption] = React.useState(false); // state that locks the deletion of first option because is the only one

    /**
     * Initialize dropdown button text and dropdown menu options on open of data element pop up
     * and when dropdown button has been updated ( add/delete option, delete of another dropdown button component)
     */
    useEffect( () => {

        setDropdownButtonText(components[formRowIndex][indexComponent].label);
        setOptions(components[formRowIndex][indexComponent].options);

    },[openAlert, clickedChangeElement])

    /**
     * This useEffect is runned when first option of dropdown menu is clicked to be deleted
     */
    useEffect( () => {
        if(clickedDeleteFirst === true){

            const lengthOptions = components[formRowIndex][indexComponent].options.length;

            // If first option is the only option then state of lockDeleteOption is set to first
            if(lengthOptions === 1){
                setLockDeleteOption(true);
            }
            // UseEffect will run again in order to set lockDeleteOption to false if needed
            setClickedDeleteFirst(false);
        }
        // If lockDeleteOption is set to true then we wait 2 seconds in order to display proper error message and then set lockDeleteOption again to false
        if(lockDeleteOption === true){
            setTimeout(() => {
                setLockDeleteOption(false)  
            }, 2000);
        }

    },[clickedDeleteFirst])

    // Edit text of dropdown button component
    const handleTextButton = (val) => {
        setDropdownButtonText(val.target.value);
        const tempComponents = [...components];
        tempComponents[formRowIndex][indexComponent].label = val.target.value;
        setComponents(tempComponents);
    }

    // Edit label name of dropdown menu option
    const handleOptionLabel = (val ,index) => {
        // Update options
        const tempOptions = [...options];
        tempOptions[index] = val.target.value;
        setOptions(tempOptions);

        // Update components of dropdown menu 
        const tempComponents = [...components];
        tempComponents[formRowIndex][indexComponent].options[index] = val.target.value;
        setComponents(tempComponents);
    }

    // Delete option of dropdown menu
    const deleteOption = (index) => {

        const optionsLength = components[formRowIndex][indexComponent].options.length;

        // Check if first and only element is going to be deleted
        if(index === 0 && optionsLength === 1){
            setClickedDeleteFirst(true);
        }
        else{
            // Delete option and update components
            const tempComponents = [...components];
            tempComponents[formRowIndex][indexComponent].options.splice(index,1);
            setComponents(tempComponents);

            setClickedChangeElement(true); // Render again dropdown button component
        }

    }

    // Add dropdown menu option
    const addOption = () => {

        const tempComponents = [...components];

        const optionsLength = components[formRowIndex][indexComponent].options.length;

        tempComponents[formRowIndex][indexComponent].options.push(`Link${(optionsLength+1).toString()}`)
        setComponents(tempComponents);

        setClickedChangeElement(true); // Render again dropdown button component
    }

    // Delete dropdown button component
    const deleteElement = () => {

        // update components
        const tempComponents = [...components];
        tempComponents[formRowIndex].splice(indexComponent,1);
        setComponents(tempComponents);

        // update types of fields
        const tempTypeFields = [...typeFields];
        tempTypeFields[formRowIndex].splice(indexComponent,1);
        setTypeFields(tempTypeFields);
        setClickedChangeElement(true); 
    } 

    return(

        <DropdownComponent 
            deleteElement = {deleteElement}
            handleTextButton = {handleTextButton}
            dropdownButtonText = {dropdownButtonText}
            options = {options}
            handleOptionLabel = {handleOptionLabel}
            lockDeleteOption = {lockDeleteOption}
            deleteOption = {deleteOption}
            addOption = {addOption}
        />
    )

}

export default DropdownDataComponent;